import { Encumbrance } from 'types';

export const isActiveEncumbrance = ({
  encumbrance,
}: {
  encumbrance?: Encumbrance;
}): boolean => {
  const endDate = encumbrance?.endDate;

  if (!endDate || typeof endDate !== 'string') {
    return true;
  }

  const endDateOnly = endDate.slice(0, 10);

  if (!/^\d{4}-\d{2}-\d{2}$/.test(endDateOnly)) {
    return true;
  }

  const today = new Date().toLocaleDateString('en-CA');

  return endDateOnly >= today;
};
